import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'filterPhone',
        component: () => import("@/views/filter/phone.vue"),
    },
]

const router = new VueRouter({
    mode: 'hash',
    routes
})

export default router
